import { Pipe, PipeTransform } from '@angular/core';

import { hasLength } from '@mtna/lib-ui';

import { TableDimension } from './models';

@Pipe({
  name: 'rdsTabCellIds',
})
export class RdsGetTableDimDatumCellIdsPipe implements PipeTransform {
  transform(dim: TableDimension): string[] {
    if (!dim || !hasLength(dim.datumCellValues)) {
      return [];
    }
    return dim.datumCellValues.map((cell) => cell.id);
  }
}
